<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Lotação
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                :value="content.local"
                label="Local de Lotação"
                readonly
                outlined
                dense
                hide-details="true"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <span>O local de lotação é uma escola ou creche?</span>
              <v-radio-group
                v-model="content.ehEscola"
                hide-details
                mandatory
                readonly
                row
              >
                <v-radio
                  label="Não"
                  :value="false"
                ></v-radio>
                <v-radio
                  label="Sim"
                  :value="true"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-if="content.ehEscola"
                :value="content.codigo"
                label="Código da Escola"
                readonly
                outlined
                dense
                hide-details="true"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="6">
              <v-text-field
                :value="content.gre?.nome"
                label="GRE"
                readonly
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="content.municipio?.nome"
                label="Município"
                readonly
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Lotacao } from '~/commons/classes/lotacao';

export default {
  props: new DialogProps(Lotacao),
};
</script>
